// registry of all custom events used in the app. Not ideal abstraction but good
// for sanity without going and reinventing interfaces.

var customEventNames = [
  'dataCurrentTrackInfo',
  'dataNowPlayingInfo',
  'dataShowInfo',
  'dataBroadcastInfo',
  'dataHtmlPage',

  'navigationRequestStarted',
  'navigationRequestProgress',
  'navigationRequestEnded',

  'uiMediaStateChange',
  'uiMainMenuToggled',
  'uiScrollSnap',
  'uiSliderValueChanged',
  'uiUpdateSliderValue',
  'uiDidSearch',
  'uiModalDismiss',
  'uiWantsDonation',

  // Audio manager events (controls what's going to play)
  'audioWantsPlayback',
  'audioWantsSkip',
  'audioWantsPause',
  'audioWantsStop',
  'audioWantsSetVolume',
  'audioNothingToPlay',
  'audioCueSource',
  'audioClearSource',
  'audioCued',
  'audioFormatNotSupported',

  // Audio source (MP3 stream or archive) events
  'audioSourceLoading',
  'audioSourcePlaying',
  'audioSourcePaused',
  'audioSourceResumed',
  'audioSourceSeekOutOfRange',
  'audioSourceStalled',
  'audioSourceEnded',
  'audioSourceTimeUpdate',
  'audioSourceMetadataUpdate',
  'audioSourceVolumeChanged',

  'streamPlay',

  'themeChange',
  'themeWasChanged',

  'donationEnded',
  'donationStarted'
];

var eventRegistry = {};
customEventNames.forEach(function (evName) {
  eventRegistry[evName] = evName;
});

module.exports = eventRegistry;



//////////////////
// WEBPACK FOOTER
// ./src/js/core/events.js
// module id = 0
// module chunks = 0 1